module.exports = __webpack_public_path__ + "img/zarinpal.4e9123cd.svg";